import { Lock, Globe } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

type Sensitivity = 'normal' | 'confidential';

interface SensitivityBadgeProps {
  sensitivity: Sensitivity;
}

export function SensitivityBadge({ sensitivity }: SensitivityBadgeProps) {
  if (sensitivity === 'confidential') {
    return (
      <Badge variant="destructive" className="gap-1">
        <Lock className="h-3 w-3" />
        Confidential
      </Badge>
    );
  }
  return (
    <Badge variant="outline" className="gap-1">
      <Globe className="h-3 w-3" />
      Normal
    </Badge>
  );
}
